<template>
    <div>
        <div v-for="(item,index) in cate" :key="index">
            <div class="zt_tts">
                <img src="../../assets/image/ranking/i1.png" width="24" height="30" class="zt_vlm">
                <h2 class="zt_h2">{{item.title}}</h2>
                <a href="javascript:;" @click="catesearch(item.title,index)" class="zt_more">更多</a>
                <div v-for="(it,int) in item.z" :key="int">
                    <router-link :to="{path:'/shop/shopsearch', query:{cate_id:it.id}}" target="_blank" class="zt_ra">
                        {{it.title}}<em>/</em>
                    </router-link>
                </div>
            </div>

            <div class="zt_glst">
                <a href="javascript:;" @click="catesearch(item.title,index)" class="zt_aa">
                    <img src="../../assets/image/ranking/zhu-g.jpg" width="240" height="364">
                </a>
                <div v-for="(ipro,pindex) in item.p.slice(0, 7)" :key="pindex">
                    <router-link :to="{path:'/detail', query:{id:ipro.id}}" target="_blank" class="zt_aa">
                        <img :src="ipro.piclink" width="240" height="240">
                        <p class="z_tta">{{ipro.title}}</p>
                        <p class="ov">
                            <b class="left">{{ipro.price}}</b>
                            <em class="right">月销{{ipro.sale}}</em>
                        </p>
                        <p class="zt_bm">查看更多》</p>
                    </router-link>
                </div>
                
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            //数据
            cate:[],
            soncate:[],
        }
    },
    mounted() {
        this.getCateProduct();
        // this.getSonCate();
    },
    methods:{
         //获取所有商品分类
        getCateProduct() {
            this.$api.getCategory.getProductCate({}).then(res => {
                if (res.code == 200) {
                    this.cate = [];
                    var arr = res.result.cate;
                    arr.forEach((item,index) => {
                        if (item.show == 1) {
                            this.cate.push(item);
                        }
                    });
                    this.type = res.result.types;
                }
            }).catch(err=>{});
        },
         //获取所有子分类
        // getSonCate() {
        //     this.$api.getCategory.getSonCate({}).then(res => {
        //         if (res.code == 200) {
        //             this.soncate = [];
        //             var arr = res.result.soncate;
        //             arr.forEach((item,index) => {
        //                 if (item.show == 1) {
        //                     this.soncate.push(item);
        //                 }
        //             });
        //             this.type = res.result.types;
        //         }
        //     });
        // },
        catesearch(title,index){
            if(index == 0){
                this.$router.push(`/woman/`);
            }else if(index == 1){
                this.$router.push(`/man/`);
            }else if(index == 2){
                this.$router.push(`/biyuntao/`);
            }else if(index == 3){
                this.$router.push(`/zhuxing/`);
            }else if(index == 4){
                this.$router.push(`/lingleiwanju/`);
            }else if(index == 5){
                this.$router.push(`/tehui/`);
            }
        }
    }
}
</script>

<style scoped>
body{background:#eee url(../../assets/image/ranking/bg01.jpg) 50% 168px no-repeat;}
.topbar{width:990px;}
.wp{width:990px;}
.fa_dl{width:164px;}
.dlast{width:163px;}
.w990,.zt_page{width:990px;margin:0 auto;}
.zt_page{overflow: hidden;font-family:"Microsoft Yahei";}
.t_god{width:494px;height:280px;overflow:hidden;display:inline;float:left;margin-bottom:1px;_margin-bottom:0; background-color: #000;_background-color: #fff;}
.t_god img,.zt_w3 img,.w_ztm{-webkit-transition:all 0.3s;-moz-transition:all 0.3s;transition:all 0.3s;}
.t_god:hover img{opacity:0.8;}
.ml1{margin-left:1px;}
.ml2{margin-left:3px;}
.w_ztul{overflow:hidden;zoom:1;margin:20px 0;}
.w_ztul li{width: 33.3%;float:left; line-height: 38px;overflow: hidden; white-space: nowrap;}
.w_zta{display: block;width: 100%; font-size: 16px;margin:5px 0;color:#333; overflow: hidden; text-overflow: ellipsis;}
.w_zta img{display:inline-block;margin-right:10px;vertical-align: middle;}
.w_zta:hover{ background-color: #ddd;color:#c40000; text-decoration: none;}
.zt_w3{width:328px;height:110px; display: inline; float: left; background-color: #000;_background-color: #eee;}
.zt_w3:hover img{opacity:0.8;}
.w_ztb{width:54px;height:80px; line-height: 30px;color:#333;float:left; text-align: center;display: inline;margin:30px 50px 0 0;}
.w_ztbb{margin-right:0;}
.w_ztb:hover{text-decoration: none;color:#c40000;}
.w_ztb:hover .w_ztm{-webkit-transform:scale(0.9); -moz-transform:scale(0.9);transform:scale(0.9);}
.zt_tts{padding-top:20px;background: url(../../assets/image/ranking/ht.png) 0 0 repeat-x; overflow: hidden;zoom:1; line-height: 30px;margin:40px 0 10px 0;}
.zt_vlm{ display:inline-block;float: left;margin-right:10px;}
.zt_h2{float: left;font-size:20px;color:#000; font-weight: bold; display: inline-block;}
.zt_ra{float:right;color:#777; font-size: 14px;}
.zt_ra:hover{color:#c40000;}
.zt_tts em{float:right;color:#cacaca;margin:0 10px;}
.zt_more{float:right;color:#000; background: url(../../assets/image/ranking/more.png) right 50% no-repeat;padding-right:25px; font-size: 14px;}

.zt_glst{width:1000px;margin-left:-10px;}
.zt_aa{width:240px;height:364px;display: inline;float: left; overflow: hidden;margin:10px 0 0 10px;color:#333; background-color: #fff; line-height:20px;}
.z_tta{padding:0 10px;font-size:14px;height: 40px; overflow: hidden;margin:5px 0;}
.zt_aa .ov{margin:10px 0;}
.zt_aa .left{color:#c40000; font-size: 16px;margin-left:10px;}
.zt_aa .right{color:#999;margin-right: 10px;}
.zt_bm{width:220px;height: 26px; background-color: #e74573; line-height: 26px;color:#fff; text-align: center;margin:0 auto;}
.zt_aa:hover{text-decoration: none;color:#c40000;}
.zt_aa:hover .zt_bm{ background-color: #c40000;}

.gfix{ position: fixed;left:0;top:0;width:100%;z-index:100;_position:relative;}
.gtops{display:block;width:30px;height:30px;padding:10px;background-color:#333;position: fixed;left:50%;bottom:80px;margin-left: 520px;z-index:10;}
.hid{display:none;}
.fl_open_wrap{display:none;position:fixed;z-index:99999;left:0;bottom:55px;width:190px;height:185px;overflow:hidden;}
.fl_open_wrap .fl_open_wrap_cntr{position:absolute;left:0;top:0;width:100%;height:100%;background:url(http://qu.dddxi.com/topic/xpcrexiao/themes/v4/css/2/fl_open.png) no-repeat;cursor: pointer;background-size: contain;}
.fl_pop_wrap{display:none;position:fixed;z-index:99998;left:0;bottom:0;width:100%;height:200px;overflow:hidden;}
.fl_open_show{position:absolute;left:-100%;bottom:0;width:100%;z-index: 210}
.fl_open_bg{width:100%;height:170px;background:rgba(26,22,55,1);z-index:-200;position: relative;}
.fl_open_m{width: 790px;height: 170px;position: absolute;bottom:0;left: 50%;z-index: 200;margin-left: -395px;opacity: 1}
.fl_pop_wrap .fl_pop_ttl,.fl_pop_wrap input,.fl_pop_wrap .fl_pop_btn_normal{font-family:"Microsoft YaHei","Hiragino Sans GB";}
.fl_pop_wrap .fl_close{position:absolute;top:10px;right:0;font-size:38px;line-height:1.2;font-family:Simsun;color:#9aa1a8;outline:0 none;}
#erma{display:none}

.w_ztm{width:54px;height:54px;}
</style>


// WEBPACK FOOTER //
// src/components/common/public-ranking.vue